import { render } from "./FloorMap.vue?vue&type=template&id=e39aff4e"
import script from "./FloorMap.vue?vue&type=script&lang=js"
export * from "./FloorMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__